import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {TeamsTableComponent} from "./components/teams-table/teams-table.component";
import {TeamsTableRowComponent} from "./components/teams-table-row/teams-table-row.component";
import {GroupsModule} from "../../groups/angular/groups.module";

@NgModule({
  declarations: [
    TeamsTableComponent,
    TeamsTableRowComponent
  ],
  imports: [
    BrowserModule,
    ScrollingModule,
    CommonsModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    GroupsModule
  ],
  providers: [],
  exports: []
})

export class TeamsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapTeamsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(TeamsModule);
};

export const downgradedTeamsModule = downgradeModule(bootstrapTeamsModule);
